// @flow
import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import Datepicker from 'antd/lib/date-picker';
import Button from 'antd/lib/button/button';
import {formatDateTimeToISOString} from '../../../../lib/helpers';
import {Filter} from './../../../../components';
import type {FilterChildrenParams} from '../../../../components/hoc/Filter';
import Spoiler from '../../../../components/ui/Spoiler';
import OrgUnitSelect from '../../../../components/OrgUnitSelect';
import Grid, {GridItem} from '../../../../components/layout/Grid';
import Field from '../../../../components/card/Field';
import Input from 'antd/lib/input';
import VehicleModelSelect from '../../../../components/selects/VehicleModelSelect';

const SpoilerContent = styled.div`
  padding: 16px;
`;

const Footer = styled(GridItem)`
  & > * {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

const {RangePicker} = Datepicker;

export type RegisterContractTripsFilter = {
  branchId?: number,
  startDate?: string,
  endDate?: string,
  vehicleModelId?: number,
  licensePlate?: string,
};

type Props = {
  filter: any,
  onExport: Function,
  cleanFilter: Function,
  applyFilter: Function
};

export default ({filter, cleanFilter, applyFilter}: Props) => (
  <Spoiler defaultExpanded label="Параметры">
    <Filter
      cleanFilter={cleanFilter}
      applyFilter={applyFilter}
      initialValues={filter}
    >
      {({
        values,
        changeValue,
        applyFilter,
        cleanFilter,
      }: FilterChildrenParams<RegisterContractTripsFilter>) => (
        <SpoilerContent>
          <Grid gutter="16px" media={[{size: 'lg', cols: 3}]}>
            <GridItem>
              <Field label="Филиал">
                <OrgUnitSelect
                  onlyBranches
                  value={values.branchId}
                  onChange={value => changeValue('branchId', value)}
                  isFilter={true}
                />
              </Field>
            </GridItem>
            <GridItem>
              <Field label="Отчетный период">
                <RangePicker
                  style={{height: '35px'}}
                  format="DD.MM.YYYY HH:mm"
                  placeholder={['Начало', 'Конец']}
                  value={[
                    values.startDate ? moment.utc(values.startDate) : null,
                    values.endDate ? moment.utc(values.endDate) : null,
                  ]}
                  onChange={(value, dateString) => {
                    const [startDate, endDate] = value;
                    const [startDateString, endDateString] = dateString;
                    changeValue(
                      'startDate',
                      formatDateTimeToISOString(startDate, startDateString),
                    );
                    changeValue(
                      'endDate',
                      formatDateTimeToISOString(endDate, endDateString),
                    );
                  }}
                />
              </Field>
            </GridItem>
            <GridItem>
              <Field label="Модель ТС">
                <VehicleModelSelect
                  value={values.vehicleModelId}
                  onChange={value => changeValue('vehicleModelId', value)}
                />
              </Field>
            </GridItem>
            <GridItem>
              <Field label="Госномер ТС">
                <Input
                  value={values.licensePlate}
                  onChange={({target}) => changeValue('licensePlate', target.value)}
                  placeholder='Введите госномер ТС'
                />
              </Field>
            </GridItem>
            <Footer fullWidth>
              <Button type="primary" onClick={applyFilter}>
                Применить
              </Button>
              <Button type="secondary" onClick={cleanFilter}>
                Очистить
              </Button>
            </Footer>
          </Grid>
        </SpoilerContent>
      )}
    </Filter>
  </Spoiler>
);
